import { emailString, requiredString } from 'src/utils/schemas';
import * as Yup from 'yup';

export const onboardingInfoValidationSchema = Yup.object().shape({
	email: emailString.optional(),
	mobile: requiredString.optional().nullable(),
	givenNames: requiredString,
	lastNames: requiredString,
});
